export * from './User'
export * from './Kyc'
export * from './Education'
export * from './Work'
export * from './TrainerProfile'
export * from './Certification'
export * from './Skill'
export * from './TrainerPackage'
export * from './Client'
export * from './Password'
export * from './Dashboard'
export * from './ClientDto'
// export *  from './user'



// WEBPACK FOOTER //
// ./src/models/index.js